// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607230603/js/" + chunkId + "." + {"44":"e8217cd0","225":"5cdb8b7e","481":"de9f0f20","486":"ce0f5a69","770":"175e8af7"}[chunkId] + ".0.47681219546963394.chunk.js";
};